import React from 'react';
import { Card, CardMedia } from '@material-ui/core';

export const MyCard = ({ card }: any) => (
 <Card>
  <CardMedia image={card.thumbUrl} style={{ height: 250, width: '100%' }} />
 </Card>
);
